import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Card, Spin, Drawer } from 'antd';
import { useSelector } from 'react-redux';
import './Restaurant.css';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { falseyValueCases } from '../CommonLogics/CommonMethods';
import isObject from 'lodash/isObject';
import { FiEdit2 } from 'react-icons/fi';
import UpdateOperationTime from './UpdateOperationTime';

const OprationTiming = (props) => {
  const {
    restaurantDetailId,
    setrestaurantDetailId,
    setTabkey,
    editId,
    setEditId,
  } = props;
  const [width] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const { restaurant, restaurantdeatils, isUpdateRestaurantLoading } =
    useSelector((state) => {
      const { restaurant, restaurantdeatils, isUpdateRestaurantLoading } =
        state.restaurant;
      return {
        restaurant,
        restaurantdeatils,
        isUpdateRestaurantLoading,
      };
    });

  const orgOTTime = restaurantdeatils?.operation_timing;
  const weekdayKeys = Object.keys(orgOTTime || {});
  const orgTimeZone = restaurantdeatils?.organization_time_zone;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const onTimeEdit = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <Spin spinning={isUpdateRestaurantLoading}>
      <Card
        style={{
          backgroundColor: '0 0 0 30px #f6f6f6 inset',
          border: 'rgb(229, 229, 229,1)',
        }}
      >
        <Row style={{ marginBottom: '20px' }}>
          <Col span={8}>
            <Typography className='days'>Operational Timing</Typography>
          </Col>
          <Col span={8} style={{ textAlign: 'right', cursor: 'pointer' }}>
            <FiEdit2 fontSize={18} onClick={onTimeEdit} />
          </Col>
        </Row>
        <Row>
          <Col xl={16} lg={16} md={16} sm={24} xs={24}>
            {weekdayKeys?.map((day, i) => {
              const dayTime = orgOTTime?.[day];

              return (
                <Col key={day} span={24} className='dayRow'>
                  <Row align='middle'>
                    <Col span={8} className='daysContainer'>
                      <Typography className='days'>{day}</Typography>
                    </Col>
                    <Col className='timeBox' span={16}>
                      <TimeChip data={dayTime} orgTimeZone={orgTimeZone} />
                    </Col>
                  </Row>

                  {/* {i !== weekdayKeys?.length - 1 && (
                    <Divider style={{ paddingTop: 16, marginBottom: 16 }} />
                  )} */}
                </Col>
              );
            })}
          </Col>
        </Row>
        <Drawer
          open={isDrawerOpen}
          placement='right'
          title='Edit Operational Timing'
          // padding={24}
          onClose={onTimeEdit}
          width={width > 400 ? '550px' : '100%'}
        >
          <UpdateOperationTime
            data={orgOTTime}
            orgTimeZone={orgTimeZone}
            onClose={onTimeEdit}
            orgDetailsId={restaurantdeatils?.id}
          />
        </Drawer>
        {/* <Row
            gutter={[22, 22]}
            className='button'
            justify='center'
            style={{ width: '550px' }}
          >
            <Col span={24}></Col>
            <Col xl={7} lg={8} md={8} sm={12} xs={12}>
              <Button className='cancelButton' onClick={handleClose}>
                Cancel
              </Button>
            </Col>
            <Col xl={7} lg={8} md={8} sm={12} xs={12}>
              <Button className='editDesignationButton' htmlType='submit'>
                Update
              </Button>
            </Col>
          </Row> */}
      </Card>
    </Spin>
  );
};

const TimeChip = ({ data, orgTimeZone }) => {
  const isOpen = data?.is_open;
  const openForAllDay = data?.is_open_all_day;
  const timeSlots = data?.hours || [];

  return (
    <div className='timeChip'>
      {isOpen ? (
        openForAllDay ? (
          <Typography className='openAllDay'>Open all day</Typography>
        ) : (
          <div style={{ textAlign: 'center' }}>
            {timeSlots.map((slot, i) => {
              const startTime = slot?.start_time
                ? moment(slot.start_time).format('hh:mm A')
                : '';

              const endTime = slot?.end_time
                ? moment(slot.end_time).format('hh:mm A')
                : '';

              const fullTime = `${startTime} - ${endTime}`;

              return (
                <React.Fragment key={i}>
                  <div className='timeRow'>
                    <span className='timing'>{fullTime}</span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        )
      ) : (
        <Typography className='openAllDay'>Closed</Typography>
      )}
    </div>
  );
};

export default OprationTiming;
